import type { Option } from '@/modules/common/types/option.type.ts';

export type CounterpartyManagerSections = {
  addresses: boolean;
  contacts: boolean;
  bankDetails: boolean;
  subordination: boolean;
  comment: boolean;
};

export type CounterpartyManagerForm = {
  manager: Option<number> | null;
  segment: Option<number> | null;
  region: Option<number> | null;
  city: Option<string> | null;
  sections: CounterpartyManagerSections;
};

export function createEmptyManagerForm(): CounterpartyManagerForm {
  return {
    manager: null,
    segment: null,
    region: null,
    city: null,
    sections: {
      addresses: false,
      contacts: false,
      bankDetails: false,
      subordination: false,
      comment: false,
    },
  };
}
